module.exports = __webpack_public_path__ + "static/media/icon-result.ab0cf724.svg";